var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { OutsourceReconciliationManageService } from '~/services/domain-service/outsource-reconciliation-manage.service';
var CreateBill = /** @class */ (function (_super) {
    __extends(CreateBill, _super);
    function CreateBill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            batchNumber: '',
            outsourceId: ''
        };
        _this.creatBillRules = {
            outsourceId: [{ required: true, message: '请选择受托方', trigger: 'blur' }],
            batchNumber: [{ required: true, message: '请选择批次号', trigger: 'blur' }],
        };
        // 下拉选批次号
        _this.batchNumberSet = [];
        _this.content = {
            outsourceName: '',
            caseSum: '',
            billSuccessSum: '',
            billFailSum: '',
            unbillSum: ''
        };
        return _this;
    }
    CreateBill.prototype.refreshData = function () { };
    CreateBill.prototype.close = function () {
    };
    CreateBill.prototype.refreshBatchNumber = function () {
        var _this = this;
        this.batchNumberSet.length = 0;
        //切换受托方后清空batchnumber
        this.model.batchNumber = '';
        if (!this.model.outsourceId) {
            this.model.batchNumber = '';
            return;
        }
        this.content.outsourceName = this.outSourceList.find(function (v) { return v.id === _this.model.outsourceId; }).outsName;
        this.outsourceReconciliationManageService.selectBatchNumberList({ outsourceId: this.model.outsourceId }).subscribe(function (data) { return _this.batchNumberSet = data; });
    };
    CreateBill.prototype.refreshContent = function () {
        var _this = this;
        if (this.model.batchNumber) {
            this.outsourceReconciliationManageService.caseStatistics(this.model).subscribe(function (data) {
                _this.content.caseSum = data.distributeNumber || 0;
                _this.content.billSuccessSum = data.successNumber || 0;
                _this.content.billFailSum = data.failureNumber || 0;
                _this.content.unbillSum = data.unCheckNumber || 0;
            });
        }
    };
    /**
     * 确认对账
     */
    CreateBill.prototype.commit = function () {
        var _this = this;
        var form = this.$refs['create-bill'];
        form.validate(function (valid) {
            if (!valid)
                return;
            var param = { batchNumber: _this.model.batchNumber, outId: _this.model.outsourceId };
            _this.outsourceReconciliationManageService.generatingBill(param).subscribe(function (data) {
                _this.$message.success('生成账单成功');
                _this.close();
                _this.refreshData();
            });
        });
    };
    CreateBill.prototype.refresh = function () {
        var form = this.$refs['create-bill'];
        form.resetFields();
    };
    __decorate([
        Dependencies(OutsourceReconciliationManageService)
    ], CreateBill.prototype, "outsourceReconciliationManageService", void 0);
    __decorate([
        State
    ], CreateBill.prototype, "outSourceList", void 0);
    __decorate([
        Emit('refreshData')
    ], CreateBill.prototype, "refreshData", null);
    __decorate([
        Emit('close')
    ], CreateBill.prototype, "close", null);
    __decorate([
        Watch('model.outsourceId', { immediate: true })
    ], CreateBill.prototype, "refreshBatchNumber", null);
    __decorate([
        Watch('model.batchNumber', { immediate: true })
    ], CreateBill.prototype, "refreshContent", null);
    CreateBill = __decorate([
        Component({})
    ], CreateBill);
    return CreateBill;
}(Vue));
export default CreateBill;
